import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useState } from 'react';
import { LANGUAGES } from '../greivanceRedressal.constants';
import { GreivanceRedressalComponentStyled } from './greivanceRedressalComponent.styled';

const GreivanceRedressalComponent = () => {
  const [language, selectedLanguage] = useState('en');
  const updateLanguage = (event: SelectChangeEvent) => {
    setTimeout(() => {
      selectedLanguage(event.target.value as string);
    });
  };
  return (
    <GreivanceRedressalComponentStyled>
      <Typography variant="h3">Grievance Redressal Policy</Typography>
      <div className="language-selector-container">
        <Typography variant="subtitle1" className="language-heading">
          Language:
        </Typography>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={language}
          displayEmpty
          onChange={updateLanguage}
          className="language-selector"
        >
          {Object.values(LANGUAGES).map((language, index) => (
            <MenuItem
              key={index}
              value={language.lang}
              style={{
                fontSize: '14px'
              }}
            >
              {language.langTitle}
            </MenuItem>
          ))}
        </Select>
      </div>
      <iframe
        key={language}
        src={LANGUAGES[language].url}
        className="iframe"
      ></iframe>
    </GreivanceRedressalComponentStyled>
  );
};

export default GreivanceRedressalComponent;
